<template>
  <v-list>
    <OmissionLoader
      :initial-leading-count="6"
      :initial-trailing-count="0"
      :load-more="loadMoreForumItems"
      :page-size="batchSize"
      :total-count="999999999"
    >
      <template v-slot:item="{ item }">
        <ForumTopic
          :forum-item="item"
          v-if="item.forum_item_type === 'Topic'"
        />
        <ForumEvent
          :forum-item="item"
          v-if="item.forum_item_type === 'Event'"
        />
      </template>
      <template #loading>
        <NewListItemLoadingSkeleton />
      </template>
      <template #loadMore="{ loadMore }">
        <div class="text-center">
          <TextButton :label="`Weitere laden`" @click="loadMore" />
        </div>
      </template>
    </OmissionLoader>
  </v-list>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import ForumTopic from "features/topics/ForumTopic.vue"
import { forumItemsApi } from "store/api"
import OmissionLoader from "features/omission-loader/OmissionLoader.vue"
import { Identifiable } from "features/common/shared/polymorphic"
import TextButton from "components/UI/TextButton.vue"
import ForumEvent from "features/topics/ForumEvent.vue"
import NewListItem from "components/NewListItem.vue"
import ConnectIcon from "components/icons/ConnectIcon.vue"
import AccessIcon from "features/common/ui/AccessIcon.vue"
import NewListItemLoadingSkeleton from "components/NewListItemLoadingSkeleton.vue"

export default defineComponent({
  name: "LatestForumItems",
  components: {
    NewListItemLoadingSkeleton,
    AccessIcon,
    ConnectIcon,
    NewListItem,
    ForumEvent,
    TextButton,
    OmissionLoader,
    ForumTopic,
  },
  setup() {
    const loadMoreForumItems = (offset: number, limit: number) =>
      forumItemsApi
        .getForumItems(offset, limit, "desc")
        .then((response) => response.data as unknown as Identifiable[])
    const batchSize = 13
    return {
      loadMoreForumItems,
      batchSize,
    }
  },
})
</script>

<style scoped></style>
